import $http from "@/services/Http";
import { prefix } from "@/api/config";
import { paginatedResponseToClass, responseToClass } from "@/api/lib";
import ProjectAccessRequest from "@/models/ProjectAccessRequest";
import { AxiosPromise, AxiosResponse } from "axios";

export function list(
  organizationId: string
): AxiosPromise<ProjectAccessRequest[]> {
  return $http
    .get(`${prefix}/organizations/${organizationId}/project-access-requests`)
    .then((response) => responseToClass(ProjectAccessRequest, response));
}

export function approve(
  organizationId: string,
  requestId: string,
  message?: string
): AxiosPromise<ProjectAccessRequest> {
  const data = message ? { message } : {};

  return $http
    .put(
      `${prefix}/organizations/${organizationId}/project-access-requests/${requestId}/approve`,
      data
    )
    .then((response) => responseToClass(ProjectAccessRequest, response));
}

export function reject(
  organizationId: string,
  requestId: string,
  reason: string
): AxiosPromise<ProjectAccessRequest> {
  const data = { message: reason };

  return $http
    .put(
      `${prefix}/organizations/${organizationId}/project-access-requests/${requestId}/reject`,
      data
    )
    .then((response) => responseToClass(ProjectAccessRequest, response));
}
